var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"containerBackgroundTable bg-primary"},[_c('taskExportHeader')],1),_c('div',[_c('taskTable',{staticClass:"alignTablaSobreFondo ml-5 mr-5 mt-6"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }